import React, { useState, useEffect } from "react";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Space, Button, Row, Col, Table, Modal, Input, DatePicker, Typography, Card, Select as ANTDSelect, Tooltip } from "antd";
import Select from "react-select";
import _ from "lodash";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";

const NEW_ITEM_BASE_STATE = {
  name: "",
  description: "",
  default_price: null,
  qbo_accounts_xref: null,
  qbo_accounts_object: null,
  qbo_id: null,
  qbo_sync_token: 0,
  qb_item_name: null,
  qb_account: null,
  qb_payment_method: null,
  billing_statuses_xref: null,
  item_categories_xref: null,
  invoice_discount_item: 0,
  payment_item: 0,
  is_taxable: 1,
  form_due_date: null,
};

function Items(props) {
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [itemCategories, setItemCategories] = useState([]);
  const [billingStatuses, setBillingStatues] = useState([]);
  const [qboAccounts, setQBOAccounts] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState(900);
  const [newItem, setNewItem] = useState(NEW_ITEM_BASE_STATE);

  const [isQBOEnabled, setIsQBOEnabled] = useState(false);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Default Price",
      dataIndex: "default_price",
      key: "default_price",
      render: (text) => (text ? props.FormatNumberToCurrency(text) : ""),
    },

    {
      title: "Default Billing Status",
      dataIndex: "billing_status_name",
      key: "billing_status_name",
    },
    {
      title: "Item Category",
      dataIndex: "item_category_name",
      key: "item_category_name",
    },
    {
      title: "Form Due Date",
      dataIndex: "form_due_date",
      key: "form_due_date",
      render: (text) => (text ? props.MakeDateTimeReadable(text) : ""),
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              let item = items.find((f) => f.id === text);
              let item_category = itemCategories.find((f) => f.id === item.item_categories_xref);
              let billing_status = billingStatuses.find((f) => f.id === item.billing_statuses_xref);
              let qbo_account = qboAccounts.find((f) => f.id == item.qbo_accounts_xref);
              setSelectedItem({
                ...item,
                form_due_date: item.form_due_date ? dayjs(item.form_due_date) : null,
                item_categories_object: item_category,
                item_categories_name: item_category?.name,
                item_categories_xref: item_category?.id,
                billing_statuses_object: billing_status,
                billing_statuses_name: billing_status?.name,
                billing_statuses_xref: billing_status?.id,
                qbo_accounts_object: qbo_account,
                qbo_accounts_name: qbo_account?.name,
                qbo_accounts_xref: qbo_account?.id,
              });
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedItem(items.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetItems = async () => {
    let response = await props.AxiosRequest("/api/items/get");
    setItems(response.data.items);
    setFilteredItems(response.data.items);
  };
  const UpdateItem = async () => {
    await props.AxiosRequest("/api/items/update", { ...selectedItem, form_due_date: selectedItem.form_due_date ? dayjs(selectedItem.form_due_date).format("YYYY-MM-DD HH:mm:ss") : null });
    GetItems();
    setEditModalOpen(false);
    setSelectedItem(null);
  };
  const DeleteItem = async () => {
    await props.AxiosRequest("/api/items/delete", { id: selectedItem.id });
    GetItems();
    setDeleteModalOpen(false);
    setSelectedItem(null);
  };
  const AddItem = async () => {
    if (newItem.name.length === 0 || newItem.description.length === 0 || !newItem.item_categories_xref || !newItem.billing_statuses_xref || (isQBOEnabled && !newItem.qbo_accounts_xref))
      return props.MakeNotification("warning", "Please input required fields.");
    if (isNaN(newItem.default_price)) return props.MakeNotification("warning", "Make sure default price is a valid number.");
    let response = await props.AxiosRequest("/api/items/insert", {
      ...newItem,
      form_due_date: newItem.form_due_date ? dayjs(newItem.form_due_date).format("YYYY-MM-DD HH:mm:ss") : null,
    });
    if (response?.status === 200) {
      setAddModalOpen(false);
      setNewItem(NEW_ITEM_BASE_STATE);
      GetItems();
    }
  };

  //

  const GetItemCategories = async () => {
    let response = await props.AxiosRequest("/api/item-categories/get");
    setItemCategories(
      response.data.item_categories.map((m) => {
        return { ...m, label: m.name, value: m.name };
      }),
    );
  };
  const GetBillingStatuses = async () => {
    let response = await props.AxiosRequest("/api/billing-statuses/get");
    setBillingStatues(
      response.data.billing_statuses.map((m) => {
        return { ...m, label: m.name, value: m.name };
      }),
    );
  };
  const GetCompanyQBOEnabled = async () => {
    let response = await props.AxiosRequest("/api/companies/get");
    setIsQBOEnabled(response.data.company.qbo_enabled === 1 ? true : false);
  };
  const GetQBOAccounts = async () => {
    let response = await props.AxiosRequest("/api/qbo-accounts/get");
    setQBOAccounts(
      response.data.qbo_accounts.map((m) => {
        return { ...m, value: m.name, label: m.name };
      }),
    );
  };

  useEffect(() => {
    GetItems();
    GetBillingStatuses();
    GetItemCategories();
    GetCompanyQBOEnabled();
  }, []);

  useEffect(() => {
    const resize = () => {
      const maxSize = Math.min(900, window.innerWidth);
      setModalWidth(maxSize);
    };
    window.addEventListener("resize", resize);
  });
  useEffect(() => {
    if (isQBOEnabled) GetQBOAccounts();
  }, [isQBOEnabled]);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredItems(items);
    let filtered_list = items.filter((f) =>
      _.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ||
      _.toLower(f.default_price).indexOf(_.toLower(searchTerm)) > -1 ||
      _.toLower(f.billing_status_name).indexOf(_.toLower(searchTerm)) > -1 ||
      _.toLower(f.item_category_name).indexOf(_.toLower(searchTerm)) > -1
        ? true
        : false,
    );
    setFilteredItems(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Items</h1>
        </div>
        <Row>
          <Card
            title={<>Items</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewItem({ ...NEW_ITEM_BASE_STATE, idemp_token: uuidv4() });
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Add A New Item
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table columns={table_columns} dataSource={filteredItems} />
          </Card>
        </Row>
        <Modal
          title={"Edit Item"}
          centered
          width={modalWidth}
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedItem(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedItem(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateItem();
                }}
              >
                Update
              </Button>
            </>
          }
        >
          {selectedItem ? (
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col span={12}>
                <label className="col-form-label-sm">Item Name *</label>
                <Input
                  placeholder="Example: 1040"
                  value={selectedItem.name}
                  onChange={(e) => {
                    setSelectedItem({ ...selectedItem, name: e.target.value });
                  }}
                />
              </Col>
              <Col span={12}></Col>
              <Col span={12}>
                <label className="col-form-label-sm">Item Category *</label>
                <Row>
                  <div style={{ width: "100%" }}>
                    <Select
                      placeholder="Select an Item Category"
                      value={selectedItem?.item_categories_object || null}
                      options={itemCategories}
                      onChange={(object) => {
                        if (object) setSelectedItem({ ...selectedItem, item_categories_name: object.name, item_categories_xref: object.id, item_categories_object: object });
                      }}
                    />
                  </div>
                </Row>
              </Col>
              <Col span={12}>
                <label className="col-form-label-sm">Default Billing Status *</label>
                <Row>
                  <div style={{ width: "100%" }}>
                    <Select
                      placeholder="Select a Default Billing Status"
                      value={selectedItem?.billing_statuses_object || null}
                      options={billingStatuses}
                      onChange={(object) => {
                        setSelectedItem({ ...selectedItem, billing_statuses_name: object.name, billing_statuses_xref: object.id, billing_statuses_object: object });
                      }}
                    />
                  </div>
                </Row>
              </Col>
              <Col span={24}>
                <label className="col-form-label-sm">Item Description *</label>
                <Input
                  placeholder={"Example: Preparation of " + dayjs().subtract(1, "year").format("YYYY") + " Individual Federal Income Tax Return - Form 1040"}
                  value={selectedItem.description}
                  onChange={(e) => {
                    setSelectedItem({ ...selectedItem, description: e.target.value });
                  }}
                />
              </Col>
              <Col span={12}>
                <label className="col-form-label-sm">Default Price</label>
                <Input
                  value={selectedItem.default_price}
                  addonBefore="$"
                  onChange={(e) => {
                    setSelectedItem({ ...selectedItem, default_price: e.target.value });
                  }}
                />
              </Col>
              <Col span={12}>
                <label className="col-form-label-sm">Form Due Date</label>
                <DatePicker
                  format={"MM/DD/YYYY"}
                  style={{ width: "100%" }}
                  value={selectedItem.form_due_date}
                  onChange={(e) => {
                    setSelectedItem({ ...selectedItem, form_due_date: e });
                  }}
                />
              </Col>
              {isQBOEnabled ? (
                <>
                  <Col span={24}>
                    <hr />
                  </Col>
                  <Col span={24}>
                    <Typography.Title level={5}>QuickBooks Online Fields</Typography.Title>
                  </Col>
                  <Col span={12}>
                    <label className="col-form-label-sm">QuickBooks Online Account *</label>
                    <div style={{ width: "100%" }}>
                      <Select
                        placeholder="Select a QuickBooks Online Account"
                        value={selectedItem?.qbo_accounts_object}
                        options={qboAccounts}
                        onChange={(object) => {
                          setSelectedItem({ ...selectedItem, qbo_accounts_xref: object.id, qbo_accounts_name: object.name, qbo_accounts_object: object });
                        }}
                      />
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <Col span={24}>
                    <hr />
                  </Col>
                  <Col span={24}>
                    <Typography.Title level={5}>QuickBooks Desktop Fields</Typography.Title>
                  </Col>
                  <Col span={12}>
                    <label className="col-form-label-sm">QuickBooks Desktop Item Name</label>
                    <Input
                      value={selectedItem.qb_item_name}
                      onChange={(e) => {
                        setSelectedItem({ ...selectedItem, qb_item_name: e.target.value });
                      }}
                    />
                  </Col>
                  <Col span={12}>
                    <label className="col-form-label-sm">QuickBooks Desktop Account</label>
                    <Input
                      value={selectedItem.qb_account}
                      onChange={(e) => {
                        setSelectedItem({ ...selectedItem, qb_account: e.target.value });
                      }}
                    />
                  </Col>
                </>
              )}
            </Row>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedItem(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedItem(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteItem();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedItem ? <>Are you sure you want to delete the items {selectedItem?.name}?</> : null}
        </Modal>

        <Modal
          title="Add A New Item"
          centered
          width={modalWidth}
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setNewItem(NEW_ITEM_BASE_STATE);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setNewItem(NEW_ITEM_BASE_STATE);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddItem();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newItem ? (
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col span={12}>
                <label className="col-form-label-sm">Item Name *</label>
                <Input
                  placeholder="Example: 1040"
                  value={newItem.name}
                  onChange={(e) => {
                    setNewItem({ ...newItem, name: e.target.value });
                  }}
                />
              </Col>
              <Col span={12}></Col>
              <Col span={12}>
                <label className="col-form-label-sm">Item Category *</label>
                <Row>
                  <div style={{ width: "100%" }}>
                    <Select
                      placeholder="Select an Item Category"
                      value={newItem?.item_categories_object || null}
                      options={itemCategories}
                      onChange={(object) => {
                        if (object) setNewItem({ ...newItem, item_categories_name: object.name, item_categories_xref: object.id, item_categories_object: object });
                      }}
                    />
                  </div>
                </Row>
              </Col>
              <Col span={12}>
                <label className="col-form-label-sm">Default Billing Status *</label>
                <Row>
                  <div style={{ width: "100%" }}>
                    <Select
                      placeholder="Select a Default Billing Status"
                      value={newItem?.billing_statuses_object || null}
                      options={billingStatuses}
                      onChange={(object) => {
                        setNewItem({ ...newItem, billing_statuses_name: object.name, billing_statuses_xref: object.id, billing_statuses_object: object });
                      }}
                    />
                  </div>
                </Row>
              </Col>
              <Col span={24}>
                <label className="col-form-label-sm">Item Description *</label>
                <Input
                  placeholder={"Example: Preparation of " + dayjs().subtract(1, "year").format("YYYY") + " Individual Federal Income Tax Return - Form 1040"}
                  value={newItem.description}
                  onChange={(e) => {
                    setNewItem({ ...newItem, description: e.target.value });
                  }}
                />
              </Col>
              <Col span={12}>
                <label className="col-form-label-sm">Default Price</label>
                <Input
                  value={newItem.default_price}
                  addonBefore="$"
                  onChange={(e) => {
                    setNewItem({ ...newItem, default_price: e.target.value });
                  }}
                />
              </Col>
              <Col span={12}>
                <label className="col-form-label-sm">Form Due Date</label>
                <DatePicker
                  format={"MM/DD/YYYY"}
                  style={{ width: "100%" }}
                  value={newItem.form_due_date}
                  onChange={(e) => {
                    setNewItem({ ...newItem, form_due_date: e });
                  }}
                />
              </Col>
              {isQBOEnabled ? (
                <>
                  <Col span={24}>
                    <hr />
                  </Col>
                  <Col span={24}>
                    <Typography.Title level={5}>QuickBooks Online Fields</Typography.Title>
                  </Col>
                  <Col span={12}>
                    <label className="col-form-label-sm">QuickBooks Online Account *</label>
                    <div style={{ width: "100%" }}>
                      <Select
                        placeholder="Select a QuickBooks Online Account"
                        value={newItem.qbo_accounts_object}
                        options={qboAccounts}
                        onChange={(object) => {
                          setNewItem({ ...newItem, qbo_accounts_xref: object.name, qbo_accounts_name: object.name, qbo_accounts_object: object });
                        }}
                      />
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <Col span={24}>
                    <hr />
                  </Col>
                  <Col span={24}>
                    <Typography.Title level={5}>QuickBooks Desktop Fields</Typography.Title>
                  </Col>
                  <Col span={12}>
                    <label className="col-form-label-sm">QuickBooks Desktop Item Name</label>
                    <Input
                      value={newItem.qb_item_name}
                      onChange={(e) => {
                        setNewItem({ ...newItem, qb_item_name: e.target.value });
                      }}
                    />
                  </Col>
                  <Col span={12}>
                    <label className="col-form-label-sm">QuickBooks Desktop Account</label>
                    <Input
                      value={newItem.qb_account}
                      onChange={(e) => {
                        setNewItem({ ...newItem, qb_account: e.target.value });
                      }}
                    />
                  </Col>
                </>
              )}
            </Row>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default Items;
